import axios, { AxiosResponse } from 'axios';

import { getExports, getAuthorizationTokens } from 'services';

import { StrapiJWTResponse } from './types';

const getStrapiEndpoint = async () => {
  const endpoints = await getExports();
  return endpoints.strapiUrl;
};

const getStrapiJWTToken = async () => {
  const { accessToken, idToken, refreshToken } = await getAuthorizationTokens();
  const strapiUrl = await getStrapiEndpoint();

  try {
    const { data } = await axios.post<void, AxiosResponse<StrapiJWTResponse>>(
      `${strapiUrl}/cognito/callback`,
      {
        access_token: accessToken,
        id_token: idToken,
        refresh_token: refreshToken,
      },
    );

    return data.jwt;
  } catch {
    throw new Error('Failed to retrieve strapi auth token');
  }
};

export { getStrapiEndpoint, getStrapiJWTToken };
